/*
 * Decléor — Cart count badge
 * ---------------------------------------------------------------------------
 * Keeps the cart-icon count badge ([data-cart-badge]) in sync with the cart.
 * The initial value is server-rendered in Liquid; this listener updates it on
 * every add/remove/update via the theme's existing `theme:cart:change` event
 * (the same event the header total/count already rely on). No dependencies.
 */
(function () {
  'use strict';

  function update(count) {
    var n = parseInt(count, 10);
    if (isNaN(n)) {
      n = 0;
    }
    var badges = document.querySelectorAll('[data-cart-badge]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      badges[i].classList.toggle('cart-count-badge--empty', n <= 0);
    }
  }

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event && event.detail && event.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') {
      update(cart.item_count);
    }
  });
})();
